export default __webpack_public_path__ + "271abab05d513a362f2e9aa1f8b9e764.webp";